module.exports = __webpack_public_path__ + "img/icon-core1-3.3ec206f6.png";